import React from 'react';
export function SocialProofBar() {
  const metrics = [{
    number: '800+',
    label: 'Pages of Coaching Resources'
  }, {
    number: '550+',
    label: 'Drills & Games'
  }, {
    number: '200',
    label: 'Ready-to-Use Session Plans'
  }, {
    number: '4.9/5',
    label: '⭐ Coach Rating'
  }];
  return <section className="bg-forest border-y border-white/10 py-8 px-4" data-id="element-204">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x-0 md:divide-x divide-white/10" data-id="element-205">
        {metrics.map((metric, index) => <div key={index} className="flex flex-col items-center justify-center px-4" data-id="element-206">
            <span className="font-display text-4xl md:text-5xl text-amber mb-1" data-id="element-207">
              {metric.number}
            </span>
            <span className="text-sm md:text-base text-gray-300 font-medium uppercase tracking-wide" data-id="element-208">
              {metric.label}
            </span>
          </div>)}
      </div>
    </section>;
}